export default __webpack_public_path__ + "static/media/image-1.26650db8.jpg";